module.exports = __webpack_public_path__ + "static/img/3-design-b3.d9d0cd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-design-b3.jpg
// module id = tIE6
// module chunks = 0